










































import { Component, Vue, Inject } from "vue-property-decorator";
import Footer from "../components/Footer.vue";
import iView from "iview";
import AbpBase from "../lib/abpbase";
@Component({
  components: { Footer },
})
export default class Login extends AbpBase {
  loginModel = {
    userNameOrEmailAddress: "",
    password: "",
    rememberMe: false,
  };
  showChangeTenant: boolean = false;
  async login() {
    (this.$refs.loginform as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$Message.loading({
          content: this.L("LoginPrompt"),
          duration: 0,
        });
        await this.$store.dispatch({
          type: "app/login",
          data: this.loginModel,
        });
        sessionStorage.setItem(
          "rememberMe",
          this.loginModel.rememberMe ? "1" : "0"
        );
        location.reload();
      }
    });
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  rules = {
    userNameOrEmailAddress: [
      { required: true, message: "请输入用户名", trigger: "blur" },
    ],
    password: [
      { required: true, message: "请输入密码", trigger: "blur" },
    ],
  };
  created() {}
}
